import { Injectable } from '@angular/core';
import { Role } from '@parashift/shared/models';
import { RoleType } from '@parashift/shared/types';
import { ServiceDecorator } from './decorators';
import { BaseApiService } from './base';
import { Endpoint } from '../env.service';

@Injectable({
  providedIn: 'root'
})
@ServiceDecorator({
  model: () => Role,
  endpointUrl: RoleType
})
export class RoleService extends BaseApiService<Role> {
  className = RoleService;

  constructor() {
    super();
    this.baseUrl = Endpoint.id;
    this.apiVersion = this.environment.endpoints.version
  }
}
